import { picturePLaceholder } from "assets/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaRegCircle } from "react-icons/fa";
import { FiCheckCircle } from "react-icons/fi";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { IoRadioButtonOffOutline } from "react-icons/io5";
import { MdOutlineRadioButtonChecked } from "react-icons/md";
import { getValueOrFallback, isArrayEmpty } from "utils/commonHelper";

const SingleChoiceQuestion = ({ data, index, showAnswer, prevCount }) => {
  const { t } = useTranslation();

  return (
    <div className="survey_card">
      {showAnswer && (
        <h5 className="field_type">
          <span className="type_icon">
            {prevCount + data?.questionNumber} <FaRegCircle />
          </span>{" "}
          {t(`CUSTOMIZATION_QUESTION.singleChoice`)}
        </h5>
      )}

      <label className="label">
        <b>{!showAnswer && prevCount + data?.questionNumber}</b>
        {getValueOrFallback(data?.question)}
      </label>
      {data?.questionImage && (
        <div className="question_image">
          <img
            src={data?.questionImage || picturePLaceholder}
            alt="question file"
          />
        </div>
      )}
      <ul className="multiple_choice rank">
        {!isArrayEmpty(data?.option) &&
          data?.option.map((option, idx) => {
            if (option.optionValue) {
              return (
                <li
                  className={`has_checkbox ${
                    showAnswer && option.isSelected === true ? "active" : ""
                  }`}
                  key={`Option-${idx + 1}`}
                >
                  {showAnswer && option.isSelected ? (
                    <FiCheckCircle />
                  ) : (
                    <IoRadioButtonOffOutline />
                  )}
                  <span>{getValueOrFallback(option.optionValue)}</span>
                  {option?.optionImage && (
                    <div className="option_image">
                      <img
                        alt="question file"
                        src={option.optionImage || picturePLaceholder}
                      />
                    </div>
                  )}
                </li>
              );
            }
          })}
      </ul>
    </div>
  );
};

export default SingleChoiceQuestion;
